// extracted by mini-css-extract-plugin
export default {"signIn":"SignIn_signIn__CBYd2","description":"SignIn_description__MIEX5","formControls":"SignIn_formControls__RSmrB","alert":"SignIn_alert__QI-Nq"};